import { useEffect } from 'react'
import { ProgramGrid } from '../components/program-grid'
import { setMetaTag } from '../utils/setMetaTag'

function App() {
  useEffect(() => {
    document.title = `Guia TV`

    setMetaTag(
      'meta[name="description"]',
      'Encontre a programação dos canais de TV'
    )
    setMetaTag('meta[property="og:title"]', `Guia TV`)
    setMetaTag(
      'meta[property="og:description"]',
      'Encontre a programação dos canais de TV'
    )
  }, [])
  return <ProgramGrid />
}

export default App
